import { APP_LOAD, ADD_CACHE, DELETE_CACHE, LOGOUT } from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case ADD_CACHE:
      let objCache = state[action.tableId] ? state[action.tableId] : [];
      let newCache = [action.obj];
      objCache.forEach(oldObj => {
        if(action.obj.id !== oldObj.id) {
          newCache.push(oldObj);
        }
      });
      if(newCache.length > 10) {
        newCache = newCache.slice(0, 10);
      }
      let cacheUpdate = {};
      cacheUpdate[action.tableId] = newCache;
      return {...state, ...cacheUpdate};
    case DELETE_CACHE:
      let tempCache = state[action.tableId] ? state[action.tableId] : [];
      let trimmedCache = {};
      trimmedCache[action.tableId] = tempCache.filter(obj => obj.id !== action.dataId);
      return {...state, ...trimmedCache};
    case LOGOUT:
      return {};
    default:
      return state;
  }
};
